// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityActionSearch-module__action-btn--jkjpz";
var _2 = "pfx-CommunityActionSearch-module__action-done--zF61h";
var _3 = "pfx-CommunityActionSearch-module__avatar--FQeR_";
var _4 = "#000";
var _5 = "pfx-CommunityActionSearch-module__bottom-sheet--pAzPp";
var _6 = "1260px";
var _7 = "1020px";
var _8 = "668px";
var _9 = "1550px";
var _a = "pfx-CommunityActionSearch-module__container--C2bNx";
var _b = "1140px";
var _c = "940px";
var _d = "100%";
var _e = "15px";
var _f = "620px";
var _10 = "#f53535";
var _11 = "rgba(0,0,0,.2)";
var _12 = "rgba(255,255,255,.38)";
var _13 = ".38";
var _14 = "pfx-CommunityActionSearch-module__dropdown--PVBuH";
var _15 = "pfx-CommunityActionSearch-module__error-icon--S6Nfz";
var _16 = "rgba(255,255,255,.2)";
var _17 = "pfx-CommunityActionSearch-module__extra-name--fx7ON";
var _18 = "#0025ff";
var _19 = "pfx-CommunityActionSearch-module__glitch-anim--cgpMJ";
var _1a = "pfx-CommunityActionSearch-module__glitch-anim-2--vs5gP";
var _1b = "#f60";
var _1c = "#41ead4";
var _1d = "#2cdd78";
var _1e = "#66ab23";
var _1f = "#f5f5f5";
var _20 = "#c3c3c3";
var _21 = "#ececec";
var _22 = "#252525";
var _23 = "#272727";
var _24 = "#c6c6c5";
var _25 = "#333";
var _26 = "#3c3c3c";
var _27 = "#9c9b9b";
var _28 = "#8c8c8c";
var _29 = "#6f6f6e";
var _2a = "#3c3c3b";
var _2b = "#373737";
var _2c = "#6a6a69";
var _2d = "#6f6f6f";
var _2e = "#9f9e9e";
var _2f = "#282828";
var _30 = "#828181";
var _31 = "#1d1d1d";
var _32 = "#979797";
var _33 = "#9c9b9b";
var _34 = "#a7a7a6";
var _35 = "#c6c6c5";
var _36 = "#d8d8d7";
var _37 = "#dddddc";
var _38 = "pfx-CommunityActionSearch-module__header--qtSwo";
var _39 = "72px";
var _3a = "40px";
var _3b = "36px";
var _3c = "25px";
var _3d = "18px";
var _3e = "13px";
var _3f = "pfx-CommunityActionSearch-module__header-title--qJ2hi";
var _40 = "pfx-CommunityActionSearch-module__input--AIqhr";
var _41 = "#0025ff";
var _42 = "rgba(255,255,255,.12)";
var _43 = "#6535f5";
var _44 = "2px";
var _45 = "56px";
var _46 = "56px";
var _47 = "pfx-CommunityActionSearch-module__no-results--SuwVx";
var _48 = "#41ead4";
var _49 = "#f60";
var _4a = "#f83600";
var _4b = "#881f00";
var _4c = "18px";
var _4d = "15px";
var _4e = "red";
var _4f = "pfx-CommunityActionSearch-module__result--uDRhp";
var _50 = "pfx-CommunityActionSearch-module__result-name--jcVuq";
var _51 = "pfx-CommunityActionSearch-module__row--EG2zl";
var _52 = "pfx-CommunityActionSearch-module__search-btn--DtMQ8";
var _53 = "pfx-CommunityActionSearch-module__search-container--cCsN7";
var _54 = "pfx-CommunityActionSearch-module__search-icon--8IOIG";
var _55 = "13px";
var _56 = "rgba(255,255,255,.07)";
var _57 = "#35465c";
var _58 = "#55acee";
var _59 = "#fff";
var _5a = "#ffce36";
var _5b = "#ffcd00";
var _5c = "red";
export { _1 as "actionBtn", _2 as "actionDone", _3 as "avatar", _4 as "black", _5 as "bottomSheet", _6 as "breakLarge", _7 as "breakMedium", _8 as "breakSmall", _9 as "breakVLarge", _a as "container", _b as "containerLarge", _c as "containerMedium", _d as "containerMobile", _e as "containerPaddingMobile", _f as "containerSmall", _10 as "danger", _11 as "darkElement", _12 as "disabled", _13 as "disabledOpacity", _14 as "dropdown", _15 as "errorIcon", _16 as "extraLightElement", _17 as "extraName", _18 as "facebook", _19 as "glitchAnim", _1a as "glitchAnim2", _1b as "google", _1c as "green", _1d as "green2", _1e as "greenColor", _1f as "grey1", _20 as "grey10", _21 as "grey2", _22 as "grey25", _23 as "grey27", _24 as "grey3", _25 as "grey33", _26 as "grey3C", _27 as "grey4", _28 as "grey41", _29 as "grey5", _2a as "grey6", _2b as "grey61", _2c as "grey6A", _2d as "grey6F", _2e as "grey7", _2f as "grey8", _30 as "grey82", _31 as "grey9", _32 as "grey97", _33 as "grey9C", _34 as "greyA7", _35 as "greyC6", _36 as "greyD8", _37 as "greyDd", _38 as "header", _39 as "header1", _3a as "header2", _3b as "header3", _3c as "header4", _3d as "header5", _3e as "header6", _3f as "headerTitle", _40 as "input", _41 as "klein", _42 as "lightElement", _43 as "lilac", _44 as "menuBorder", _45 as "menuHeight", _46 as "menuMobileHeight", _47 as "noResults", _48 as "ocean", _49 as "orange", _4a as "orange2", _4b as "orangeDark", _4c as "paragraph", _4d as "paragraphSmall", _4e as "red", _4f as "result", _50 as "resultName", _51 as "row", _52 as "searchBtn", _53 as "searchContainer", _54 as "searchIcon", _55 as "subHeaderSmall", _56 as "subtleLightElement", _57 as "tumblr", _58 as "twitter", _59 as "white", _5a as "yellow", _5b as "yellowDeep", _5c as "youtube" }
